import { Album } from '../../../../types';
import { useStationMode } from '@hooks/station';
import { HomeWisdomAlbumGrid } from './HomeWisdomAlbumGrid';

interface HomeWisdomGridProps {
  albums: Album[];
}

export const HomeWisdomGrid = ({ albums }: HomeWisdomGridProps) => {
  const isStationMode = useStationMode();
  // Show loading state when no albums are available
  if (albums.length === 0) {
    return (
      <div id="audiobooks-grid" className="relative w-full pl-4 sm:pl-6">
        <div className="flex gap-[16px] overflow-x-auto snap-x snap-mandatory scroll-smooth hide-scrollbar scrollbar-hide select-none w-full">
          {[...Array(4)].map((_, index) => (
            <div
              key={`loading-${index}`}
              className={`flex-shrink-0 snap-start ${
                isStationMode ? 'w-[282px]' : 'w-[371px]'
              }`}>
              <div
                className={`relative w-full rounded-[16px] animate-pulse overflow-hidden shadow-[0_4px_16px_0_rgba(0,0,0,0.40)] ${
                  isStationMode ? 'h-[395px]' : 'h-[520px]'
                }`}
                style={{
                  background:
                    'linear-gradient(180deg, #3B4758 0%, #000000 100%)',
                }}>
                {/* Badge skeleton */}
                <div className="absolute top-[16px] left-[16px] z-[100] w-[110px] h-[40px] bg-gray-600/50 rounded-full"></div>

                {/* Center Book Cover skeleton */}
                <div className="absolute inset-0 flex top-[80px] justify-center z-[50]">
                  <div className="w-[185px] h-[275.1px] rounded-[8px] bg-gray-600/50 shadow-lg"></div>
                </div>

                {/* Bottom Section skeleton */}
                <div className="absolute z-[100] bottom-0 left-0 p-5 flex flex-col gap-3 w-full">
                  {/* Album name skeleton */}
                  <div className="h-[28px] bg-gray-600/50 rounded w-4/5"></div>

                  {/* Contributor info skeleton */}
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2 flex-1">
                      <div className="w-[56px] h-[56px] rounded-full bg-gray-600/50 flex-shrink-0"></div>
                      <div className="h-[18px] bg-gray-600/50 rounded w-32"></div>
                    </div>
                    <div className="flex items-center gap-1">
                      <div className="h-[12px] bg-gray-600/50 rounded w-8"></div>
                      <div className="w-[14px] h-[14px] bg-gray-600/50 rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <HomeWisdomAlbumGrid
      storeKey="wisdomPlaylist"
      gridId="audiobooks-grid"
      playlistIdPrefix="audiobooks-grid"
      randomize={false}
      selectionMode="audiobooks"
      albums={albums}
    />
  );
};
